import { Component,OnInit } from '@angular/core';

@Component({
  selector: 'ResetPasswordReq',
  templateUrl: './resetPasswordreq.html'
})

export class ResetPasswordReq implements OnInit {
    
        ngOnInit() {
    
      }
    }



// WEBPACK FOOTER //
// ./src/app/login/resetPasswordreq.page.ts